import { render, staticRenderFns } from "./ChipContainer.vue?vue&type=template&id=53a25ec2&scoped=true&"
import script from "./ChipContainer.vue?vue&type=script&lang=ts&"
export * from "./ChipContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ChipContainer.vue?vue&type=style&index=0&id=53a25ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a25ec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VIcon,VSpacer})
